import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventBroadcastService {
  private triggerSubject = new Subject<void>();

  trigger$ = this.triggerSubject.asObservable();

  triggerEvent() {
    this.triggerSubject.next();
  }
}
